import { OidcClient, CreateSigninRequestArgs } from 'oidc-client-ts'
import { createContext } from 'react'
import learnBackendRequestHandler from './learnBackendRequestHandler'
import { createUrl } from '../shared/UrlUtils/urlUtils'

let oidcClient: OidcClient | undefined

export async function getOidcClient(): Promise<OidcClient> {
	if (!oidcClient) {
		const clientID = (
			(await learnBackendRequestHandler('openIdClient')).data as any
		).client_id
		oidcClient = new OidcClient({
			authority: createUrl(import.meta.env.VITE_SECDIM_ID_BACKEND, {
				path: 'openid',
				removeTrailingSlash: true,
			}),
			client_id: clientID,
			redirect_uri: window.location.origin,
			post_logout_redirect_uri: createUrl(
				import.meta.env.VITE_SECDIM_ID_FRONTEND,
				{ path: ['account', 'logout'], removeTrailingSlash: true },
			),
			response_type: 'code',
			scope: 'openid email profile',
			filterProtocolClaims: true,
			loadUserInfo: false,
		})
	}
	return oidcClient
}

export async function handleSignIn() {
	sessionStorage.setItem('redirectURI', window.location.href)

	const createSigninRequestArgs: CreateSigninRequestArgs = {
		redirect_uri: window.location.origin,
		response_type: 'code',
		scope: 'openid email',
	}

	const client = await getOidcClient()
	client
		.createSigninRequest(createSigninRequestArgs)
		.then(req => {
			window.location.href = req.url // nosemgrep
		})
		.catch(err => {
			// eslint-disable-next-line no-console
			console.error(err)
		})
}

export const OpenIDContext = createContext({
	authenticated: null as boolean | null,
	profile: {
		firstName: '',
		lastName: '',
		username: '',
		email: '',
		guid: '',
		image: '',
		isSubscribed: false,
		isTrialAvailable: false,
		subscriptionType: '',
		restrictions: {
			hasCSEAccess: false,
			hasTopicAccess: false,
			hasDrSecDimAccess: false,
		},
	},
	refresh: () => {},
	isGlobalAlertShown: false,
	globalAlertMessage: '',
	globalAlertSeverity: 'error',
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	setIsGlobalAlertShown: (isGlobalAlertShown: boolean) => {},
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	setGlobalAlertMessage: (message: string) => {},
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	setGlobalAlertSeverity: (severity: string) => {},
})

export async function codeResponse(url: string) {
	const client = await getOidcClient()
	return client.processSigninResponse(url)
}
